/* eslint-disable no-undef, no-underscore-dangle */

import {
  SHOW_NOTIFICATIONS,
  CLOSE_NOTIFICATIONS,
  TOGGLE_NOTIFICATIONS,
  SHOW_BOOKING_MODAL,
  CLOSE_BOOKING_MODAL,
  TOGGLE_BOOKING_MODAL,
  SHOW_SETTINGS,
  CLOSE_SETTINGS,
  TOGGLE_SETTINGS,
  SHOW_MINI_CALENDAR,
  CLOSE_MINI_CALENDAR,
  TOGGLE_MINI_CALENDAR,
} from './mutation-types';

const ui = {
  state: {
    showNotifications: false,
    showBookingModal: false,
    showMiniCalendar: false,
    showSettings: false,
  },
  mutations: {
    [SHOW_NOTIFICATIONS](state) {
      state.showNotifications = true;
    },
    [CLOSE_NOTIFICATIONS](state) {
      state.showNotifications = false;
    },
    [TOGGLE_NOTIFICATIONS](state) {
      state.showNotifications = !state.showNotifications;
    },
    [SHOW_BOOKING_MODAL](state) {
      state.showBookingModal = true;
    },
    [CLOSE_BOOKING_MODAL](state) {
      state.showBookingModal = false;
    },
    [TOGGLE_BOOKING_MODAL](state) {
      state.showBookingModal = !state.showBookingModal;
    },
    [SHOW_SETTINGS](state) {
      state.showSettings = true;
    },
    [CLOSE_SETTINGS](state) {
      state.showSettings = false;
    },
    [TOGGLE_SETTINGS](state) {
      state.showSettings = !state.showSettings;
    },
    [SHOW_MINI_CALENDAR](state) {
      state.showMiniCalendar = true;
    },
    [CLOSE_MINI_CALENDAR](state) {
      state.showMiniCalendar = false;
    },
    [TOGGLE_MINI_CALENDAR](state) {
      state.showMiniCalendar = !state.showMiniCalendar;
    },
  },
  actions: {
    showNotifications({ commit }) {
      commit(SHOW_NOTIFICATIONS);
    },
    closeNotifications({ commit }) {
      commit(CLOSE_NOTIFICATIONS);
    },
    toggleNotifications({ commit }) {
      commit(TOGGLE_NOTIFICATIONS);
    },
    toggleBooking({ commit }) {
      commit(TOGGLE_BOOKING_MODAL);
    },
    showBooking({ commit }) {
      commit(SHOW_BOOKING_MODAL);
    },
    closeBooking({ commit }) {
      commit(CLOSE_BOOKING_MODAL);
    },
    toggleSettings({ commit }) {
      commit(TOGGLE_SETTINGS);
    },
    showSettings({ commit }) {
      commit(SHOW_SETTINGS);
    },
    closeSettings({ commit }) {
      commit(CLOSE_SETTINGS);
    },
    toggleMiniCalendar({ commit }) {
      commit(TOGGLE_MINI_CALENDAR);
    },
    showMiniCalendar({ commit }) {
      commit(SHOW_MINI_CALENDAR);
    },
    closeMiniCalendar({ commit }) {
      commit(CLOSE_MINI_CALENDAR);
    },
  },
};

export default ui;



// WEBPACK FOOTER //
// ./src/store/ui.js